<script setup>
import { computed } from 'vue'

/**
 * Player name, linked to their public profile.
 *
 * The name is unique in the database, so it doubles as the username in the profile URL.
 * Everything that will decorate the name later (nationality flag, titles, ...) belongs here: the
 * pages that show a player drop this component in, and they all get it at once.
 */
const props = defineProps({
  /** Player name as the API returns it. */
  name: { type: String, default: null },
})

const to = computed(() => ({ name: 'player', params: { username: props.name } }))
</script>

<template>
  <RouterLink v-if="name" :to="to" class="user-name user-name--link">
    {{ name }}
  </RouterLink>
  <span v-else class="user-name">–</span>
</template>

<style scoped>
/* The name keeps the colour of the context (table, card) and only shows itself as a link on
   hover, so a classification stays readable instead of turning into a wall of blue. */
.user-name {
  color: inherit;
  text-decoration: none;
}
.user-name--link:hover {
  color: rgb(var(--v-theme-primary));
  text-decoration: underline;
}
</style>
